import userActionConstants from '../constants/userActionConstants';

const initialState = {
  user: {},
  emails: [],
  expRewardDetails: {},
  urlProfile: {},
};

const userReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case userActionConstants.UPDATE_USER_PROFILE:
      return {
        ...state,
        user: action.payload.user,
      };
    case userActionConstants.GET_EMAILS:
      return {
        ...state,
        emails: action.payload,
      };
    case userActionConstants.CREATE_EMAIL:
      return {
        ...state,
        emails: [...state.emails, action.payload],
      };
    case userActionConstants.DELETE_EMAIL:
      return {
        ...state,
        emails: state.emails.filter(({ id }) => id !== action.payload),
      };
    case userActionConstants.VERIFY_EMAIL:
      return {
        ...state,
        emails: state.emails.map((email) => (email.email === action.payload ? { ...email, pending: false } : email)),
      };
    case userActionConstants.UPDATE_PRIMARY_EMAIL:
      return {
        ...state,
        emails: state.emails.map((email) =>
          email.id === action.payload ? { ...email, primary: true } : { ...email, primary: false }
        ),
      };
    case userActionConstants.GET_EXP_REWARD_DETAILS:
      return {
        ...state,
        expRewardDetails: action.payload,
      };
    case userActionConstants.CREATE_EXP_REWARD_DETAILS:
      return {
        ...state,
        user: { ...state.user, experiential_payment_info: true },
      };
    case userActionConstants.GET_URL_PROFILE_DETAILS:
      return {
        ...state,
        urlProfile: action.payload.user,
      };
    case userActionConstants.DELETE_COVER_IMAGE:
      return {
        ...state,
        user: { ...state.user, cover_image: null, cover_image_id: null },
      };
    default:
      return state;
  }
};

export default userReducer;
